export default __webpack_public_path__ + "static/media/fax_phone.a4384673.svg";